<template lang="html">
  <v-dialog
  v-model="dialog"
  >
  <div class="a">
  <v-img :src="image" :lazy-src="image" class="grey darken-4" width="100%" aspect-ratio="2" contain></v-img>
  <v-btn class="btn" icon dark @click="dialog = false">
    <v-icon color="white">close</v-icon>
  </v-btn>
  </div>
</v-dialog>
</template>

<script>
export default {
  data(){
    return{
      dialog: false,
      image : ''
    }
  },
  methods:{
    openDialog(original_link){
      this.dialog = true
      this.image = process.env.VUE_APP_IPFLASK + '/'+ original_link
    }
  }
}
</script>

<style scoped>
.a {
  position: relative;
}

.a img {
  /* width: 100%; */
  height: auto;
}

.a .btn {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
